module.exports = "input {\n  padding-right: 2em; }\n\n.mat-list .mat-list-item .mat-line {\n  padding-right: 2.5em; }\n"